import type { User } from '@si/types';
import { patch } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  user: Partial<User>;
}

export function useEditUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      patch({
        url: `/users/${params.user.userId}`,
        body: params.user,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(false),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(true),
      });
    },
  });

  const editUser = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    editUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
